import {LocalCache} from "oca-lib-web";
import Constants from "./Constants";

export default class CacheSettings {

    public static getCurrentProject():string {
        return LocalCache.getLocal(Constants.CACHE_PROJECT_ID);
    }

    public static saveCurrentProject(projectId:string) {
        LocalCache.saveLocal(Constants.CACHE_PROJECT_ID, projectId);
    }

    public static getCustomDate():string {
        return LocalCache.getLocal(Constants.CACHE_CUSTOM_DATE);
    }

    public static setCustomDate(value:string) {
        LocalCache.saveLocal(Constants.CACHE_CUSTOM_DATE, value);
    }

    public static save(projectId:string) {
        LocalCache.saveLocal(Constants.CACHE_PROJECT_ID, projectId);
    }

    public static getCurrentAnalyticsSettings():ReportSettings {
        let projectId = this.getCurrentProject();
        let analyticsSettings = LocalCache.getLocal(projectId + "_" + Constants.CACHE_ANALYTICS_SETTINGS);
        return analyticsSettings ? JSON.parse(analyticsSettings) : null;
    }

    public static saveCurrentAnalyticsSettings(analyticsSettings:ReportSettings) {
        let projectId = this.getCurrentProject();
        LocalCache.saveLocal(projectId + "_" + Constants.CACHE_ANALYTICS_SETTINGS, JSON.stringify(analyticsSettings));
    }

    public static clearAnalyticsSettings(projectId:string) {
        LocalCache.removeLocal(projectId + "_" + Constants.CACHE_ANALYTICS_SETTINGS);
    }

    public static getCurrentPage():string {
        let projectId = this.getCurrentProject();
        return LocalCache.getLocal(projectId + "_" + Constants.CACHE_CURRENT_PAGE);
    }

    public static saveCurrentPage(pageName:string) {
        let projectId = this.getCurrentProject();
        LocalCache.saveLocal(projectId + "_" + Constants.CACHE_CURRENT_PAGE, pageName);
    }

    public static clearCurrentPage(projectId:string) {
        LocalCache.removeLocal(projectId + "_" + Constants.CACHE_CURRENT_PAGE);
    }

    public static getCurrentTimeInterval(): string {
        return LocalCache.getLocal(Constants.CACHE_DATE);
    }

    public static saveCurrentTimeInterval(timeInterval:string) {
        LocalCache.saveLocal(Constants.CACHE_DATE, timeInterval);
    }
}